export default __webpack_public_path__ + "static/media/withdraw-ecredit-step5.b2cedbfb.png";